// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1HsPV","detailsBorder":"styles_detailsBorder__W7CcE"};